import { EXTERNAL_READ_REQUEST } from "./index";

export const loadExternalCompaniesRel = token => ({
  type: EXTERNAL_READ_REQUEST,
  payload: {
    token
  }
});
